export const suppliersSelector = (state) => state.suppliers?.suppliers;
export const loadingSuppliersSelector = (state) => state.suppliers?.loading;
